module.exports = "/_next/static/images/me-ad7afd12fc4ef2187604c530b062adac.svg";